import RouteContainer from "../../containers/RouteContainer";

/**
 * 通常ユーザーのメイン画面
 * @returns {JSX.Element}
 * @constructor
 */
const Contents = () => {
    return (
        <div className="makeStyles-content-4" style={{paddingBottom: 50}}>
            <RouteContainer/>
        </div>
    )
}
export default Contents
